export const ADD_WARRANTY = 'ADD_WARRANTY';

export const ADD_WARRANTY_SUCCESS = 'ADD_WARRANTY_SUCCESS';

export const ADD_WARRANTY_FAILED = 'ADD_WARRANTY_FAILED';

export const SET_PARAM_API_DATA = 'SET_PARAM_API_DATA';
